import { render } from "./Configuracion.vue?vue&type=template&id=d51bba14"
import script from "./Configuracion.vue?vue&type=script&lang=js"
export * from "./Configuracion.vue?vue&type=script&lang=js"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__